'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var adapter = require('./adapter.js');

const settings = {
  ADAPTER: adapter.BrowserAdapter,
  RESOLUTION: 1,
  RENDER_OPTIONS: {
    view: null,
    antialias: false,
    autoDensity: false,
    backgroundColor: 0,
    backgroundAlpha: 1,
    premultipliedAlpha: true,
    clearBeforeRender: true,
    preserveDrawingBuffer: false,
    width: 800,
    height: 600,
    legacy: false,
    hello: false
  },
  CREATE_IMAGE_BITMAP: false,
  ROUND_PIXELS: false
};

exports.settings = settings;
//# sourceMappingURL=settings.js.map
